import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { MdDeleteForever, MdEdit, MdVisibility } from "react-icons/md";
import Select from "react-select";
// import { toast } from 'react-toastify';
// import locationServices from '../../../Services/locationServices'
import trackingServices from "../../../Services/trackingService";
// import { ChangeStatus } from '../../../Components'
// import ReactPaginate from 'react-paginate'
// import Loader from '../../../Components/Loader';
// import { Badge } from 'react-bootstrap-v5';
import { useLocation } from "react-router-dom";
import Loader from "../../../Components/Loader";
import ReactPaginate from "react-paginate";
import CheckAccess from "../../../Function/CheckAccess";
let currentPage1 = 1

// const ProviderOption = [
//   { value: "BOOKING_REQUESTED", label: "Booking Requested" },
//   { value: "BOOKING_CONFIRMED", label: "Booking Confirmed" },
//   { value: "PICKUP_IN_PROCESS", label: "Pickup In Process" },
//   { value: "SHIPMENT_AT_WAREHOUSE", label: "Shipment At Warehouse" },
//   { value: "SHIPMENT_FINALIZED", label: "Shipment Finalized" },
//   { value: "UNDER_CUSTOMS_CLEARANCE", label: "Under Customs Clearance" },
//   { value: "DEPARTED", label: "Departed" },
//   { value: "ARRIVED", label: "Arrived" },
//   { value: "READY_FOR_DELIVERY", label: "Ready For Delivery" },
//   { value: "DELIVERED", label: "Delivered" },
// ];

const ProviderOption = [
  { value: "ALL", label: "All" },
  { value: "BOOKING_CONFIRMED", label: "Pick Up in progress" },
  { value: "SHIPMENT_AT_WAREHOUSE", label: "Export formalities in progress" },
  { value: "DEPARTED", label: "In transit" },
  { value: "ARRIVED", label: "Import formalities in progress" },
  { value: "DELIVERED", label: "Delivered" },
];

export const TrackingList = () => {
  const history = useHistory();
  const [dataList, setDataList] = useState([]);
  const [Active, setActive] = useState(false);
  const [serviceProvider, setServiceProvider] = useState();
  const [loader, setLoader] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);

  const location = useLocation();
  let user_type = localStorage.getItem("user_type");

  useEffect(() => {
    let Filter = { page: currentPage, limit: pagination.limit };
    if (serviceProvider) {
      Filter = { search1: serviceProvider.value };
    }
    setLoader(true);
    trackingServices.getTrackingList(Filter).then((result) => {
      if (result.status === true) {
        setDataList(result.data);
        setPagination({ ...pagination, ...result.pagination });
        setLoader(false);
      } else {
        setLoader(false);
      }
    });
  }, [serviceProvider, currentPage]);

  const searchTracking = (text) => {
    let searchString = { search: text };
    trackingServices.getTrackingList(searchString).then((result) => {
      if (result.status === true) {
        setDataList(result.data);
      }
    });
  };

  const convertToDate = (data) => {
    return new Date(data).toLocaleDateString();
  };

  const getTrackingDate = (data) => {
    let val = data?.tracking_date.map((item1) => {
      if (item1.job_status === data.job_status) {
        return convertToDate(item1.tracking_date);
      }
    });
    return val;
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };


  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-sm-3">
                <input
                  style={{ height: "38px" }}
                  type="text"
                  className={"form-control"}
                  placeholder="Search..."
                  onKeyUp={(e) => searchTracking(e.target.value)}
                />
              </div>
              <div className="col-sm-3">
                <Select
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),
                    control: (provider) => ({
                      ...provider,
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                  // value={destinationCountryValue}
                  onChange={(e) => setServiceProvider(e)}
                  placeholder="Shipment Status"
                  options={ProviderOption}
                />
              </div>

              {/* <button className="btn btn-primary w-sm waves-effect waves-light"
                                onClick={() => history.push('/add-tracking')}
                            >Add Tracking
                            </button> */}
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th> Job No.</th>
                    <th> Customer Name</th>
                    <th>Shipment Status</th>
                    <th>Status Date</th>
                    {/* <th> Status Bar</th> */}
                    <th> Expected Delivery Date</th>
                    <th> Action</th>
                  </tr>
                </thead>
                <tbody>
                  {dataList.map((item, index) => {
                    return (
                      <tr key={index}>
                        {/* <td scope="row">{index + 1}</td> */}
                        <td className="text-body fw-bold">
                          {(currentPage - 1) * pagination.limit + (index + 1)}
                        </td>
                        <td>{item?.job_token}</td>
                        <td>{item?.user_full_name}</td>
                        <td>{item?.job_status}</td>
                        <td>{item?.tracking_date && getTrackingDate(item) || "-"}</td>
                        {/* <div className="dropdown d-inline-block">
                                                <button type="button" className="btn btn-sm btn-success" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Pick Up Arranged

                                                    <i className="uil-angle-down d-none d-xl-inline-block font-size-15" />
                                                </button>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    
                                                    <a className="dropdown-item" href="#">  <span className="align-middle">Pick Up Arranged</span></a>
                                                    <a className="dropdown-item" href="#">  <span className="align-middle">Shipment Departed</span></a>
                                                    <a className="dropdown-item" href="#">  <span className="align-middle">Shipment Arrived at Destination</span></a>
                                                    <a className="dropdown-item" href="#">  <span className="align-middle">Customs Cleared</span></a>
                                                    <a className="dropdown-item" href="#">  <span className="align-middle">Shipment Delivered</span></a>
                                                </div>
                                            </div> */}

                        {/* <td>{ item?.expected_delivery_date?convertToDate(item.expected_delivery_date):"" }</td> */}
                        <td>
                          {item?.expacted_date
                            ? convertToDate(item.expacted_date)
                            : ""}
                        </td>

                        <td>
                          {(CheckAccess(45,"edit") ||
                            user_type === "SUPERADMIN") && (
                            <MdEdit
                              className="pointer"
                              onClick={() =>
                                history.push(
                                  `edit-tracking?id=${item.job_token}`
                                )
                              }
                              color="#0323fe"
                              size="25px"
                            />
                          )}
                          {/* <MdDeleteForever
                                                    // className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                    className="pointer"
                                                    color="red"
                                                    size="25px"
                                                // onClick={() => setDeleteModalOpen(item)}
                                                /> */}
                          <MdVisibility
                            className="pointer"
                            onClick={() =>
                              history.push(
                                `tracking-details?id=${item.job_token}`
                              )
                            }
                            color="#0323fe"
                            size="25px"
                          />
                        </td>
                      </tr>
                    );
                  })}

                  {/* <tr>
                                        <td scope="row">3</td>
                                        <td>4744612461</td>
                                        <td>joe</td>
                                        <td><span className="badge rounded-pill font-size-12 pointer bg-warning">Shipment Departed</span></td>
                                        
                                        <td>22 May, 2013</td>
                                        <td>
                                            <MdEdit
                                                className="pointer"
                                                onClick={() => history.push('edit-tracking')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                            <MdDeleteForever
                                                // className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                className="pointer"
                                                color="red"
                                                size="25px"
                                            // onClick={() => setDeleteModalOpen(item)}
                                            />
                                            <MdVisibility
                                                className="pointer"
                                                onClick={() => history.push('tracking-details')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                        </td>
                                    </tr> */}
                </tbody>
              </table>
              {dataList && dataList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

              {dataList &&
                dataList.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}

              <Loader isShow={loader} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
